import React from "react";

const HelpCenterTopics = ({ helpTopicsList }) => {
  return (
    <>
      <div className="row mt-10 mt-sm-20 mt-md-35 mt-lg-50">
        {helpTopicsList.map((item, index) => (
          <div className="col-12 col-md-6 col-lg-4 mb-20" key={index}>
            <div className="px-15 px-sm-25 px-md-35 px-lg-50 py-15 h-100 d-flex flex-column card-custom">
              <div className="icon">
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0006 0.960693C13.5327 0.960686 15.0498 1.26245 16.4653 1.84875C17.8808 2.43505 19.1669 3.29441 20.2502 4.37776C21.3336 5.46111 22.193 6.74723 22.7793 8.1627C23.3656 9.57816 23.6673 11.0953 23.6673 12.6273C23.6673 19.0707 18.444 24.294 12.0006 24.294C5.55735 24.294 0.333984 19.0707 0.333984 12.6273C0.333984 6.18406 5.55735 0.960693 12.0006 0.960693ZM13.1673 13.794H10.834C7.94566 13.794 5.46597 15.5433 4.39645 18.0404C6.0887 20.4134 8.86398 21.9607 12.0006 21.9607C15.1373 21.9607 17.9126 20.4134 19.6049 18.0403C18.5354 15.5433 16.0557 13.794 13.1673 13.794ZM12.0006 4.46069C10.0676 4.46069 8.50063 6.02771 8.50063 7.96069C8.50063 9.89368 10.0676 11.4607 12.0006 11.4607C13.9336 11.4607 15.5006 9.89368 15.5006 7.96069C15.5006 6.02771 13.9337 4.46069 12.0006 4.46069Z"
                    fill="#F05203"
                  />
                </svg>
              </div>
              <h6 className="ah-text-base fw-semibold black-100">
                {item.title}
              </h6>
              <p className="ah-text-sm fw-normal black-100">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default HelpCenterTopics;
